import { render, staticRenderFns } from "./fixedSidebar.vue?vue&type=template&id=b0b21eb6&"
import script from "./fixedSidebar.vue?vue&type=script&lang=js&"
export * from "./fixedSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports